// extracted by mini-css-extract-plugin
export default {"root":"AboutMusOlymp_root__w970r"};